import { ProcessDiagram, type ProcessStep } from '@/components/help/ProcessDiagram';

// Concept-diagram wrappers for the Tier 4 mental-model articles. Each is a thin
// wrapper around <ProcessDiagram> with a hard-coded steps array. The underlying
// primitive renders the complete diagram (every node highlighted) when the
// viewer prefers reduced motion, so these honour that preference for free.

const AEO_FLOW: ProcessStep[] = [
  { label: 'User query', icon: 'IconSearch' },
  { label: 'AI answer', icon: 'IconSparkles' },
  { label: 'Your content cited', icon: 'IconQuote' },
  { label: 'Traffic', icon: 'IconChartLine' },
];

const AI_PIPELINE_FLOW: ProcessStep[] = [
  { label: 'Brainstorm persona', icon: 'IconBulb' },
  { label: 'Writer persona', icon: 'IconPencil' },
  { label: 'Reviewer persona', icon: 'IconChecklist' },
  { label: 'Illustrator persona', icon: 'IconPhoto' },
];

const PROMPT_ARCHITECTURE_FLOW: ProcessStep[] = [
  { label: 'Template', icon: 'IconTemplate' },
  { label: 'Site base', icon: 'IconWorld' },
  { label: 'Context substitution', icon: 'IconCode' },
  { label: 'Protocol suffix', icon: 'IconList' },
  { label: 'Claude API', icon: 'IconSparkles' },
];

const PUBLISHING_FLOW: ProcessStep[] = [
  { label: 'body_md', icon: 'IconFileText' },
  { label: 'Converter', icon: 'IconRefresh' },
  { label: 'MDX', icon: 'IconCode' },
  { label: 'Git push', icon: 'IconArrowUp' },
  { label: 'Cloudflare Pages', icon: 'IconWorld' },
  { label: 'CDN', icon: 'IconAffiliate' },
  { label: 'Reader', icon: 'IconEye' },
];

const THEMING_FLOW: ProcessStep[] = [
  { label: 'Preset', icon: 'IconTemplate' },
  { label: 'CSS variables', icon: 'IconCode' },
  { label: 'Tailwind', icon: 'IconColumns' },
  { label: 'Components', icon: 'IconBox' },
  { label: 'Site', icon: 'IconWorld' },
];

const COMPONENT_FLOW: ProcessStep[] = [
  { label: 'Shorthand in editor', icon: 'IconPencil' },
  { label: 'Converter', icon: 'IconRefresh' },
  { label: 'MDX tag', icon: 'IconCode' },
  { label: '@aeo/ui render', icon: 'IconBox' },
  { label: 'HTML on site', icon: 'IconWorld' },
];

export function AEODiagram(): JSX.Element {
  return <ProcessDiagram steps={AEO_FLOW} />;
}

export function AIPipelineMentalModelDiagram(): JSX.Element {
  return <ProcessDiagram steps={AI_PIPELINE_FLOW} />;
}

export function PromptArchitectureDiagram(): JSX.Element {
  return <ProcessDiagram steps={PROMPT_ARCHITECTURE_FLOW} />;
}

export function PublishingInfrastructureDiagram(): JSX.Element {
  return <ProcessDiagram steps={PUBLISHING_FLOW} />;
}

export function ThemingSystemDiagram(): JSX.Element {
  return <ProcessDiagram steps={THEMING_FLOW} />;
}

export function ComponentSystemDiagram(): JSX.Element {
  return <ProcessDiagram steps={COMPONENT_FLOW} />;
}
